import { useCallback, useState } from 'react';

import type { Player } from '@schibsted-svp/web-player';

import { useJWPlayerEvent } from '../../components/utils/useJWPlayerEvent';

import { usePlayer } from './usePlayer';

const getPlayerState = (player?: Player) => {
  try {
    return player?.getState() || 'idle';
  } catch {
    return 'idle';
  }
};

const events = [
  'buffer',
  'play',
  'pause',
  'idle',
  'adPlay',
  'adPause',
  'complete',
] as const;

export const usePlayerState = () => {
  const player = usePlayer();

  const [state, setState] = useState(getPlayerState(player));

  const handleStateChange = useCallback(() => {
    setState(getPlayerState(player));
  }, [player]);

  useJWPlayerEvent(events, handleStateChange);

  return state;
};
